import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { BloodGasAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-blood-gas-slot',
    templateUrl: './blood-gas-slot.component.html',
    styleUrl: './blood-gas-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloodGasSlotComponent implements SheetSlotComponentBase {

	@Input() action!: BloodGasAction;
	value = null;

	constructor() {
	}
}
